/**
 * Quick View component
 *
 * @module quick-view
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "quick-view-minicart";

if (!customElements.get(customElements.component)) {
  class MinicartQuickView extends HTMLElement {
    /**
     * Quick view web component
     *
     * @constructor
     */
    constructor() {
      super();

      this.initEvents();
    }

    /**
     * Init component events.
     *
     * @returns {undefined}
     */
    initEvents() {
      this.initOpenEvents();
      this.initCloseEvents();
    }

    /**
     * Init quick view open events
     *
     * @returns {undefined}
     */
    initOpenEvents() {
      const btnsOpen = document.querySelectorAll(
        ".mini-cart [data-quick-view-minicart-handle]"
      );

      btnsOpen.forEach((btn) => {
        if (!btn.classList.contains("js-active")) {
          btn.classList.add("js-active");

          btn.addEventListener("click", (event) => {
            event.preventDefault();
            this.open(btn.dataset.quickViewHandle);
          });
        }
      });
    }

    /**
     * Init quick view open events
     *
     * @returns {undefined}
     */
    initCloseEvents() {
      this.querySelectorAll("[data-quick-view-minicart-close]").forEach(
        (element) => {
          element.addEventListener("click", (event) => {
            event.preventDefault();
            this.close();
          });
        }
      );

      window.addEventListener("minicart-closed", () => this.close());
    }

    /**
     * Init the product slider
     *
     * @returns {undefined}
     */
    initSlider() {
      let slider = this.querySelector("[data-slide-init]");

      if (slider && this.enable_carousel) {
        this.slider = new Swiper(slider, {
          slidesPerView: 1,
          autoHeight: true,
          on: {
            init: () => {
              this.classList.add("active-slider");
              this.classList.add("loaded");
            },
            slideChange: (index) => {},
          },
        });
      } else {
        this.classList.add("loaded");
      }
    }

    /**
     * Destroy the product slider
     *
     * @returns {undefined}
     */
    destroySlider() {
      if (this.slider && this.enable_carousel) {
        this.slider.destroy();
        this.enable_carousel = false;
        this.classList.remove("active-slider");
      }
    }

    /**
     * Open quick view
     *
     * @param {string} handle Product handle.
     * @returns {undefined}
     */

    open(handle) {
      const oldContent = this.querySelector(".quick-view-minicart__content");

      if (oldContent) {
        oldContent.remove();
      }

      return new Promise((resolve, reject) => {
        try {
          if (this.productFetchController) this.productFetchController.abort();
          this.productFetchController = new AbortController();
          window.theme.product.loadProduct(handle, true, this.productFetchController.signal).then((product) => {
            if (!product) return;
            this.querySelector(".quick-view-minicart__overlay").classList.add(
              "active"
            );
            const quickView = document.querySelector(
              ".mini-cart [data-quick-view-minicart-container]"
            );
            const content = this.loadContent(product);

            if (quickView && content) {
              quickView.innerHTML = content;
              this.initSlider();
              this.initCloseEvents();
              this.classList.add("active");
              this.setAttribute("aria-hidden", "false");
              resolve(true);
            }
          });
        } catch (error) {
          reject(error);
        }
      });
    }

    /**
     * Close quick view
     *
     * @returns {undefined}
     */
    close() {
      if (this.productFetchController) {
        this.productFetchController.abort();
        this.productFetchController = null;
      }

      this.classList.remove("loaded");
      this.classList.remove("active");
      this.setAttribute("aria-hidden", "true");
      this.destroySlider();

      this.querySelector(".quick-view-minicart__overlay").classList.remove(
        "active"
      );
    }

    /**
     * Load quick view content
     *
     * @param {object} product Product data.
     * @returns {string} HTML code
     */
    loadContent(product) {
      let content =
        quickViewMinicartTemplate.quick_view_minicart_content_layout;

      let productImages = "";

      product.images.forEach((image) => {
        productImages += `<div class="swiper-slide quick-view-minicart__carousel-item" data-carousel-item-photo><img src="${image.src}" alt="${image.alt}" loading="lazy"/></div>`;
      });

      if (product.images.length > 1) {
        this.enable_carousel = true;
      }

      content = content.replace(/{{productImage}}/g, productImages);

      content = content.replace(/{{productTitle}}/g, product.title);

      let product_price = `<span class="quick-view-minicart__price-current" data-price>${window.theme.money.format(product.variants[0].price)}</span>`;

      if (product.variants[0].compare_at_price > 0) {
        product_price += `<span class="quick-view-minicart__price-compared" data-compareatprice>${window.theme.money.format(product.variants[0].compare_at_price)}</span>`;
      }

      content = content.replace(/{{productPrice}}/g, product_price);

      content = content.replace(/{{productId}}/g, product.id);

      content = content.replace(/{{variant}}/g, product.variants[0].id);

      content = content.replace(/{{productHandle}}/g, product.handle);

      content = content.replace(/{{productVendor}}/g, product.vendor);

      return content;
    }
  }

  customElements.define(customElements.component, MinicartQuickView);
}
